import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { portalApi } from '../lib/parceiroApi';

const ParceiroAuthContext = createContext(null);

export const ParceiroAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [parceiro, setParceiro] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('parceiro_token');
    if (!token) {
      setLoading(false);
      return;
    }
    portalApi
      .me()
      .then((res) => {
        setUser(res.data.user);
        setParceiro(res.data.parceiro);
      })
      .catch(() => {
        localStorage.removeItem('parceiro_token');
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await portalApi.login(email, password);
    localStorage.setItem('parceiro_token', res.data.access_token);
    setUser(res.data.user);
    setParceiro(res.data.parceiro);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('parceiro_token');
    setUser(null);
    setParceiro(null);
    window.location.href = '/parceiro/login';
  }, []);

  return (
    <ParceiroAuthContext.Provider value={{ user, setUser, parceiro, loading, login, logout }}>
      {children}
    </ParceiroAuthContext.Provider>
  );
};

export const useParceiroAuth = () => useContext(ParceiroAuthContext);
